/* 고객지원 연락처 — Contact by Countries(<details>) 부드러운 펼침/접힘 애니메이션.
   네이티브 details 는 즉시 토글되므로 높이를 직접 트랜지션해 열림·닫힘 모두 부드럽게 처리.
   prefers-reduced-motion 시 네이티브 즉시 토글 유지. */
(function () {
  var DURATION = 280;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bind(details) {
    if (details.dataset.animBound) return;
    details.dataset.animBound = '1';

    var summary = details.querySelector('summary');
    var content = details.querySelector('.support-contact__rte');
    if (!summary || !content) return;

    var animating = false;

    summary.addEventListener('click', function (e) {
      if (reduceMotion()) return; // 접근성: 즉시 토글
      e.preventDefault();
      if (animating) return;
      animating = true;

      var closing = details.open;
      if (!closing) details.open = true; // 열 때 먼저 표시해야 높이 측정 가능

      var full = content.scrollHeight;
      content.style.overflow = 'hidden';
      content.style.height = (closing ? full : 0) + 'px';

      // 초기 높이 반영 후 트랜지션 시작
      requestAnimationFrame(function () {
        content.style.transition = 'height ' + DURATION + 'ms ease';
        content.style.height = (closing ? 0 : full) + 'px';
      });

      var finish = function () {
        content.style.transition = '';
        content.style.height = '';
        content.style.overflow = '';
        if (closing) details.open = false;
        animating = false;
        content.removeEventListener('transitionend', onEnd);
      };
      var onEnd = function (ev) {
        if (ev.propertyName === 'height') finish();
      };
      content.addEventListener('transitionend', onEnd);
      window.setTimeout(function () { if (animating) finish(); }, DURATION + 80); // 폴백
    });
  }

  function init() {
    var list = document.querySelectorAll('.support-contact__details');
    for (var i = 0; i < list.length; i++) bind(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
